/** BookingSortControl — sort field + direction, rendered ONLY at the card
 *  breakpoints. Desktop sorts through the table's clickable column headers, so
 *  there is nothing for this control to do there. */
import { ArrowDownUp } from 'lucide-react';

import type { BookingSort, BookingSortDir } from '../../api/bookingsList';

import { CONTROL, SORT_OPTIONS } from './bookingFilterOptions';

export function BookingSortControl({
  sort,
  dir,
  onSortChange,
  onDirToggle,
}: {
  sort: BookingSort;
  dir: BookingSortDir;
  onSortChange: (v: BookingSort) => void;
  onDirToggle: () => void;
}) {
  return (
    <div className="flex items-center gap-2">
      <select
        aria-label="Sort by"
        value={sort}
        onChange={(e) => onSortChange(e.target.value as BookingSort)}
        className={CONTROL}
      >
        {SORT_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <button
        type="button"
        aria-label={`Sort direction: ${dir === 'asc' ? 'ascending' : 'descending'}`}
        onClick={onDirToggle}
        className="inline-flex items-center gap-1 rounded-lg border border-stone-200 px-2.5 py-2 text-xs text-stone-600 hover:bg-stone-50 dark:border-stone-700 dark:text-stone-300 dark:hover:bg-[#242d28]"
      >
        <ArrowDownUp size={14} />
        {dir === 'asc' ? 'Asc' : 'Desc'}
      </button>
    </div>
  );
}
